export { default as DetailsModal } from "./DetailsModal";
export { default as DetailsContainer } from "./DetailsContainer";
